import React from "react";
import { useEffect } from "react";
import classes from "./HansDemo.module.css";

const HansDemo = () => {
  const publicUrl = process.env.PUBLIC_URL || "";
  const demoUrl = `${publicUrl}/hans-demo/index.html`;

  useEffect(() => {
    console.log("[Hans demo route]", {
      browserPath: window.location.pathname,
      iframeSrc: demoUrl,
    });
  }, [demoUrl]);

  return (
    <main className={classes.Page}>
      <iframe
        className={classes.Frame}
        src={demoUrl}
        title="Hans A/S website demo"
      />
    </main>
  );
};

export default HansDemo;
